import UltMeta, { Meta } from "./UltMeta/index";

class BizOperationHistoryDef extends UltMeta {
    ELECTRONIC_FENCE_RECORDING_PROCESSING_HANDLE = new Meta(1, "电子围栏记录处理记录" );
    CLUE_PROCESSING_RECORDING_HANDLE = new Meta(2, "线索处理记录" );
}
export const BIZ_OPERATION_HISTORY_DEF = new BizOperationHistoryDef();